import React, { Component } from "react";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
// import { Link } from "react-router-dom";
import { Link, withRouter } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "react-select";
import { getdistrictlist } from "store/participantdistrict/actions";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Table,
  Button,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getanalyteevaluationreport } from "store/Payment/actions";
import { getAnalytelist } from "store/databaseofunits/actions";
import { getSchemelist } from "store/scheme/actions";
import "assets/scss/table.scss";
import { Formik, Field, Form, ErrorMessage } from "formik";
const saveFilters = filters => {
  sessionStorage.setItem("analyteReportFilters", JSON.stringify(filters));
};

const loadFilters = () => {
  const saved = sessionStorage.getItem("analyteReportFilters");
  return saved ? JSON.parse(saved) : {};
};
const getAnalyteShortName = name => {
  const mapping = {
    HBsAg: "HBsAg",
    "Anti-HAV": "A-HAV",
    "HAV IgM": "HAV M",
    HBeAg: "HBeAg",
    "Anti-HCV": "A-HCV",
    "Anti-HIV-1/2": "HIV 1/2",
    "Anti-HBc": "A-HBc",
    "Anti-HTLV-I": "A-HTLV",
    "Anti-HBs": "A-HBs",
    "Anti-HIV-2": "HIV-2",
    "HAV IgG": "HAV G",
    "Anti-HBe": "A-HBe",
    "Anti-HIV-1": "HIV-1",
    "HBc IgM": "HBc M",
    Cortisol: "Cor",
    FSH: "FSH",
    Estradiol: "E2",
    hGH: "GH",
    "DHEA Sulfate": "DHEAS",
    Folate: "Fol",
    "CA 125": "C125",
    CEA: "CEA",
    hCG: "hCG",
    "Vitamin B12": "B12",
    Testosterone: "Test",
    Ferritin: "Ferr",
    "Alpha-fetoprotein (AFP)": "AFP",
    PSA: "PSA",
    Prolactin: "PRL",
    Insulin: "",
    TSH: "TSH",
    T4: "T4",
    "T4 Free": "T4F",
    T3: "T3",
    "T3 Free": "T3F",
    Progesterone: "Prog",
    "Luteinizing Hormone (LH)": "LH",
    "25-OH Vitamin D": "25VD",
    "Intact PTH": "IPTH",
    Chloride: "Cl",
    "ALT/SGPT": "ALT",
    Creatinine: "Cr",
    "Bilirubin (Total)": "BilT",
    Calcium: "Ca",
    "Bilirubin (Direct)": "BilD",
    Glucose: "Glu",
    "CK, Total": "CK",
    "Amylase (total)": "Amy",
    "Gamma GT": "GGT",
    "Cholesterol (Total)": "Chol",
    Albumin: "Alb",
    "Alkaline Phosphatase": "ALP",
    Lithium: "Li",
    Potassium: "K",
    "LD (LDH)": "LDH",
    "Uric acid": "UA",
    TIBC: "TIBC",
    "Phosphate, inorganic": "PO₄",
    Iron: "Fe",
    Osmolality: "Osm",
    "Protein, total": "TP",
    Urea: "Urea",
    Sodium: "Na",
    Magnesium: "Mg",
    "AST/SGOT": "AST",
    Triglyceride: "TG",
  };

  return mapping[name] || name.split(" ")[0].slice(0, 3);
};
class AnalyteEvaluationReport extends Component {
  constructor(props) {
    super(props);
    const saved = loadFilters();
    this.state = {
      showDetailModal: false,
      modalData: [], // Detailed results to display
      modalTitle: "", // Optional: show analyte & lab name
      nameFilter: "",
      idFilter: "",
      districtFilter: saved.districtFilter || "",
      statusFilter: saved.statusFilter || "",
      schemeFilter: saved.schemeFilter || "",
      cycleFilter: saved.cycleFilter || "",
      resultFilter: "",
      roundNameFilter: "",
      unitFilter: "",
      methodFilter: "",
      instrumentFilter: "",
      reagentFilter: "",
      participantFilter: "",
      schemeFilter: saved.schemeFilter || "",
      schemeModalOpen: false,
      amountFilter: "",
      discountFilter: "",
      GetAnalyteEvaluation: [],
      tableKey: 0,
      feedbackMessage: "",
      totalParticipants: "",
      participantsWithResults: "",
      errorMessage: "",
      editModalOpen: false,
      selectedRow: null,
      analytes: [], // ✅ initialize
      schemes: [], // ✅ initialize
      cycles: [], // ✅ initialize
      rounds: [],
      filteredSchemes: [],
      filteredCycles: [],
      filteredRounds: [],
      analyteSummaryMap: {}, // ✅ FIXED LINE
      analyteFilter: "",
      schemeFilter: saved.schemeFilter || "",
      // cycleFilter: "",
      roundFilter: "", // ✅ initialize
      ListDistrict: [], // ✅ initialize
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      feedbackListColumns: [
        {
          dataField: "lab_name",
          text: "Participant",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell, row) => <span>{cell || "NS"}</span>,
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.participantFilter}
                  onChange={e =>
                    this.handleFilterChange("participantFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "120px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "district",
          text: "District",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell, row) => <span>{cell || "NS"}</span>,
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.districtFilter}
                  onChange={e => this.handleDistrictChange("districtFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "120px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
      ],
    };
  }
  componentDidMount() {
    const { onGetScheme } = this.props;
    const { user_id, schemeFilter } = this.state;

    if (user_id) {
      onGetScheme(user_id);
    }

    if (schemeFilter) {
      this.props.onGetAnalyteEvaluationReport(schemeFilter, user_id);
    }
  }
  fetchData() {
    const { onGetAnalyteEvaluationReport } = this.props;
    const { analyteFilter } = this.state;

    if (analyteFilter) {
      // analyteFilter must be analyte_id, not name
      onGetAnalyteEvaluationReport(analyteFilter);
    }
  }
  componentDidUpdate(prevProps) {
    console.log("🔥 componentDidUpdate called", {
      prev: prevProps.AnalyteEvaluationReport,
      current: this.props.AnalyteEvaluationReport,
      same:
        prevProps.AnalyteEvaluationReport ===
        this.props.AnalyteEvaluationReport,
    });

    const { AnalyteEvaluationReport } = this.props;

    // Only rebuild when new API data arrives
    if (AnalyteEvaluationReport !== prevProps.AnalyteEvaluationReport) {
      console.log("📥 New Report:", AnalyteEvaluationReport);

      const schemeData = AnalyteEvaluationReport?.scheme || {};
      const cycles = schemeData?.cycles || [];

      // Build lab-wise analyte summary map with both ID and name
      let analyteSummaryMap = {};
      cycles.forEach(cycle => {
        (cycle.analyte_summary || []).forEach(entry => {
          const key = `${entry.lab_id}_${entry.analyte_name}`;

          // 🔎 DEBUG: detect duplicate/colliding keys
          if (analyteSummaryMap[key]) {
            console.warn(
              "⚠️ DUPLICATE KEY in analyteSummaryMap:",
              key,
              "\n  existing entry detailed_results[0]:",
              analyteSummaryMap[key].detailed_results?.[0],
              "\n  new entry detailed_results[0]:",
              (entry.detailed_results || [])[0],
              "\n  new entry analyte_id:",
              entry.analyte_id,
              "analyte_name:",
              JSON.stringify(entry.analyte_name)
            );
          }

          const totalRounds = entry.total_rounds || 0;
          const accepted = entry.accepted || 0;
          const warning = entry.warning || 0;
          const rejected = entry.rejected || 0;
          const not_submitted = totalRounds - (accepted + warning + rejected);

          analyteSummaryMap[key] = {
            lab_id: entry.lab_id, // store lab_id
            lab_name: entry.lab_name, // store lab_name
            analyte_id: entry.analyte_id, // 🔎 keep for debugging
            analyte_name: entry.analyte_name, // 🔎 keep for debugging
            total_rounds: totalRounds,
            accepted: accepted,
            warning: warning,
            rejected: rejected,
            not_submitted: not_submitted, // ✅ added
            detailed_results: entry.detailed_results || [],
          };
        });
      });

      const districtList = AnalyteEvaluationReport?.districts || [];

      // Build table data (one row per lab)
      const analyteSet = new Set();
      const labMap = {};

      cycles.forEach(cycle => {
        (cycle.analyte_summary || []).forEach(entry => {
          const key = entry.lab_id;
          analyteSet.add(entry.analyte_name);

          if (!labMap[key]) {
            // Map district from ListDistrict
            let districtName = "N/A";
            if (Array.isArray(districtList) && districtList.length > 0) {
              if (districtList.includes(entry.district)) {
                districtName = entry.district;
              } else {
                districtName = districtList[0];
              }
            }

            labMap[key] = {
              lab_id: entry.lab_id,
              lab_name: entry.lab_name || `Lab ${entry.lab_id}`,
              district: districtName,
              cycle_no: cycle.cycle_no,
              scheme_id: schemeData.scheme_id,
              scheme_name: schemeData.scheme_name,
            };
          }

          const totalRounds = entry.total_rounds || 0;
          const accepted = entry.accepted || 0;
          const warning = entry.warning || 0;
          const rejected = entry.rejected || 0;
          const not_submitted = totalRounds - (accepted + warning + rejected);

          labMap[key][entry.analyte_name] = {
            total_rounds: totalRounds,
            accepted: accepted,
            warning: warning,
            rejected: rejected,
            not_submitted: not_submitted, // ✅ added here too
          };
        });
      });

      const flatLabs = Object.values(labMap);
      const analytesInScheme = Array.from(analyteSet);

      console.log("✅ Flattened labs:", flatLabs);
      console.log("✅ Analytes found:", analytesInScheme);
      console.log("✅ Analyte Summary Map:", analyteSummaryMap);

      // Update component state
      this.setState({
        reportScheme: schemeData,
        allLabsData: flatLabs,
        filteredCycles: cycles.map(c => c.cycle_no),
        filteredRounds: [],
        GetAnalyteEvaluation: flatLabs,
        analytesInScheme,
        analyteSummaryMap,
        ListDistrict: districtList,
      });
      saveFilters({
        schemeFilter: this.state.schemeFilter,
        cycleFilter: this.state.cycleFilter,
        districtFilter: this.state.districtFilter,
        statusFilter: this.state.statusFilter,
      });
    }
  }
  handleSchemeChange = selected => {
    const selectedSchemeId = selected?.value === "All" ? "" : selected?.value;

    // 🧹 Reset all related filters and data
    this.setState(
      {
        schemeFilter: selectedSchemeId,
        cycleFilter: "",
        roundFilter: "",
        districtFilter: "",
        statusFilter: "",
        filteredCycles: [],
        filteredRounds: [],
        GetAnalyteEvaluation: [],
        analytesInScheme: [],
        analyteSummaryMap: {},
        allLabsData: [],
        reportScheme: {},
        currentPage: 1,
      },
      () => {
        // ✅ Fetch new scheme data only AFTER resetting
        if (selectedSchemeId) {
          const { user_id } = this.state;
          this.props.onGetAnalyteEvaluationReport(selectedSchemeId, user_id);
        }
      }
    );
  };

  handleCycleChange = selected => {
    const selectedCycle = selected?.value === "All" ? "" : selected?.value;
    const { reportScheme, allLabsData } = this.state;

    // 🟩 Find selected cycle details
    const selectedCycleData = (reportScheme?.cycles || []).find(
      c => String(c.cycle_no) === String(selectedCycle)
    );

    // 🟩 Extract all round names (for dropdown)
    const roundsForCycle =
      selectedCycleData?.rounds?.map(r => r.round_name) || [];

    // 🟩 Collect analytes available in this cycle
    const analytesInCycle = [];
    (selectedCycleData?.analyte_summary || []).forEach(a => {
      if (!analytesInCycle.includes(a.analyte_name)) {
        analytesInCycle.push(a.analyte_name);
      }
    });

    // 🟩 Filter flattened labs by cycle
    let filteredLabs = allLabsData || [];
    if (selectedCycle) {
      filteredLabs = filteredLabs.filter(
        lab => String(lab.cycle_no) === String(selectedCycle)
      );
    }

    // 🟩 Update state with filtered data
    this.setState({
      cycleFilter: selectedCycle,
      roundFilter: "",
      filteredRounds: roundsForCycle,
      analytesInScheme: analytesInCycle,
      GetAnalyteEvaluation: filteredLabs, // ✅ filtered by cycle
    });
  };
  handleDistrictChange = selectedDistrict => {
    const value = selectedDistrict || "";

    this.setState(prevState => {
      let updatedColumns = [...prevState.feedbackListColumns];

      // Remove "District" column if a district is selected
      if (value && value !== "") {
        updatedColumns = updatedColumns.filter(
          col => col.dataField !== "district"
        );
      } else {
        // Add it back if cleared
        const districtColExists = updatedColumns.some(
          col => col.dataField === "district"
        );
        if (!districtColExists) {
          updatedColumns.push({
            dataField: "district",
            text: "District",
            sort: true,
            style: { textAlign: "left" },
            formatter: (cell, row) => <span>{cell || "NS"}</span>,
            headerFormatter: (column, colIndex) => (
              <div style={{ textAlign: "center" }}>
                <div>{column.text}</div>
                <div style={{ marginTop: "5px" }}>
                  <input
                    type="text"
                    value={prevState.districtFilter}
                    onChange={e => this.handleDistrictChange(e.target.value)}
                    className="form-control"
                    style={{
                      textAlign: "center",
                      width: "120px",
                      margin: "auto",
                    }}
                  />
                </div>
              </div>
            ),
          });
        }
      }

      return {
        districtFilter: value,
        feedbackListColumns: updatedColumns,
      };
    });
  };

  filterData = () => {
    const {
      GetAnalyteEvaluation,
      districtFilter = "",
      participantFilter = "",
      schemeFilter = "",
      cycleFilter = "",
      roundFilter = "",
      statusFilter = "",
      analyteSummaryMap = {},
      analytesInScheme = [],
    } = this.state;

    if (!Array.isArray(GetAnalyteEvaluation)) return [];

    return GetAnalyteEvaluation.filter(entry => {
      const matchesDistrict =
        !districtFilter ||
        (entry.district || "").toLowerCase() === districtFilter.toLowerCase();

      const matchesParticipant =
        !participantFilter ||
        (entry.lab_name || "")
          .toLowerCase()
          .includes(participantFilter.toLowerCase());

      const matchesScheme =
        !schemeFilter || String(entry.scheme_id) === String(schemeFilter);

      const matchesCycle =
        !cycleFilter || String(entry.cycle_no) === String(cycleFilter);

      const matchesRound =
        !roundFilter || String(entry.round_id) === String(roundFilter);

      // ✅ Status filter logic: only include rows where the selected status > 0
      let matchesStatus = true;
      const schemeType = this.state.reportScheme?.analytetype?.toLowerCase();
      if (statusFilter) {
        matchesStatus = analytesInScheme.some(analyte => {
          const key = `${entry.lab_id}_${analyte}`;
          const summary = analyteSummaryMap[key] || {};

          // 🟣 Qualitative logic (based on whether a result was submitted)
          if (schemeType === "qualitative") {
            const detailed = summary.detailed_results || [];
            const closedRounds = detailed.filter(
              d => d.round_status !== "Open"
            );

            const hasResultFn = d =>
              d.qualitative_result_type && d.qualitative_result_type !== "";

            if (statusFilter === "accepted") {
              return closedRounds.some(d => hasResultFn(d) && d.score === 5);
            } else if (statusFilter === "rejected") {
              return closedRounds.some(d => hasResultFn(d) && d.score === 0);
            } else if (statusFilter === "not_submitted") {
              return closedRounds.some(d => !hasResultFn(d));
            } else {
              // "All" or unrecognized → include
              return true;
            }
          }

          // 🧮 Quantitative logic (existing)
          return summary[statusFilter] > 0;
        });
      }

      return (
        matchesDistrict &&
        matchesParticipant &&
        matchesScheme &&
        matchesCycle &&
        matchesRound &&
        matchesStatus
      );
    });
  };
  handleCountClick = (labId, schemeName, cycleNo, analyte, status) => {
    console.log("🖱️ handleCountClick called with:", {
      labId,
      schemeName,
      cycleNo,
      analyte,
      status,
    });

    const { analyteSummaryMap, reportScheme } = this.state;
    const summary = analyteSummaryMap[`${labId}_${analyte}`];
    console.log(
      "🔑 Looking up key:",
      `${labId}_${analyte}`,
      "→ found summary:",
      summary
    );

    if (!summary) return;

    const labName = summary.lab_name || `Lab ${labId}`;
    const schemeType = (reportScheme?.analytetype || "").toLowerCase();

    // ✅ Qualitative logic (based on whether a result was submitted)
    if (schemeType === "qualitative") {
      const detailed = summary.detailed_results || [];
      let filteredRounds = detailed.filter(d => d.round_status !== "Open");

      // Determine status purely from whether a result was submitted
      const getQualStatus = d => {
        const isNotSubmitted = d.qualitative_result_type === "Not Submitted";
        if (isNotSubmitted) return "not_submitted";
        if (d.score === 5) return "accepted";
        if (d.score === 0) return "rejected";
        return "pending";
      };

      if (status && status !== "total_rounds") {
        filteredRounds = filteredRounds.filter(
          d => getQualStatus(d) === status
        );
      }

      // Sort rounds
      const sortedRounds = [...filteredRounds].sort((a, b) => {
        const extractNum = r => {
          if (!r?.round_name) return 0;
          const parts = r.round_name.split("-");
          const last = parts[parts.length - 1];
          return parseInt(last.replace(/\D/g, ""), 10) || 0;
        };
        return extractNum(a) - extractNum(b);
      });

      const modalRows = sortedRounds.map(d => {
        const isNotSubmitted = d.qualitative_result_type === "Not Submitted";

        let statusText = "Pending";
        if (isNotSubmitted) {
          statusText = "Not Submitted";
        } else if (d.score === 5) {
          statusText = "Accepted";
        } else if (d.score === 0) {
          statusText = "Rejected";
        }

        return {
          round_name: d.round_name || "--",
          round_id: d.round_id, // ✅ added
          participant_id: d.participant_id, // ✅ added
          instrument: d.instrument || "--",
          your_result: d.qualitative_result_type || "Not Submitted",
          expected_result: d.true_value || "--",
          score: d.score ?? 0,
          status: statusText,
        };
      });

      this.setState({
        qualitativeModalOpen: true,
        qualitativeModalData: modalRows,
        modalTitle: `${labName} - ${schemeName} - Cycle ${cycleNo} - ${analyte}`,
      });
      return;
    }

    // ✅ Quantitative logic (existing)
    const evaluationMap = {
      accepted: "acceptable",
      warning: "warning",
      rejected: "rejected",
      not_submitted: "not submitted",
    };

    const allRoundsData = (summary.detailed_results || []).filter(d => {
      if (d.round_status === "Open") return false;
      if (!status || status === "total_rounds") return true;

      const evalNormalized = (d.evaluation || "").toLowerCase();
      const statusNormalized = status.toLowerCase();

      if (statusNormalized === "not_submitted") {
        return !evalNormalized || evalNormalized === "not submitted";
      }

      const expectedEval = evaluationMap[statusNormalized] || statusNormalized;
      return evalNormalized === expectedEval;
    });

    const sortedRounds = [...allRoundsData].sort((a, b) => {
      const extractNum = r => {
        if (!r?.round_name) return 0;
        const parts = r.round_name.split("-");
        const last = parts[parts.length - 1];
        return parseInt(last.replace(/\D/g, ""), 10) || 0;
      };
      return extractNum(a) - extractNum(b);
    });

    const modalDataWithStatus = sortedRounds.map(d => ({
      ...d,
      status: d.evaluation || "Not Submitted",
    }));

    this.setState({
      showDetailModal: true,
      modalData: modalDataWithStatus,
      modalTitle: `${labName} - ${schemeName} - Cycle ${cycleNo} - ${analyte}`,
    });
  };
  prepareTableData = () => {
    const { allLabsData } = this.state;
    const labMap = {};

    allLabsData.forEach(entry => {
      const key = entry.lab_id;
      if (!labMap[key]) {
        labMap[key] = {
          lab_id: entry.lab_id,
          lab_name: entry.lab_name,
          district: entry.district,
          city: entry.city,
          province: entry.province,
        };
      }

      // Store readable evaluation text
      let evalLabel = "Not Submitted";
      if (entry.result_type === "Acceptable") evalLabel = "Acceptable";
      else if (entry.result_type === "Rejected") evalLabel = "Rejected";
      else if (entry.result_type === "Warning") evalLabel = "Warning";

      labMap[key][entry.analyte] = evalLabel;
    });

    return Object.values(labMap);
  };

  openParticipantModal = row => {
    const { GetAnalyteEvaluation } = this.state;

    // find all rounds for this participant (lab_id + analyte_id + scheme/cycle)
    const labRounds = (GetAnalyteEvaluation || []).filter(
      entry =>
        entry.lab_id === row.lab_id &&
        entry.analyte_id === row.analyte_id &&
        entry.scheme_name === row.scheme_name &&
        String(entry.cycle_no) === String(row.cycle_no)
    );

    if (!labRounds.length) {
      console.error("❌ No matching lab rounds found for row:", row);
      return;
    }

    // build participant row
    const participantRow = {
      Analyte: row.analyte_name,
      Scheme: row.scheme_name,
      Cycle: row.cycle_no,
    };

    labRounds.forEach((r, idx) => {
      participantRow[`R ${idx + 1}`] = r.instrument || "NS";
    });

    this.setState({
      participantModalOpen: true,
      selectedParticipant: row.lab_name,
      participantRows: [participantRow], // store as array
    });
  };

  handleSchemeModalClose = () => {
    this.setState({
      schemeModalOpen: false,
    });
  };

  handleMouseExit = () => {
    this.setState({
      PatientModal: false,
      MarketerModal: false,
      LabModal: false,
      isHovered: false,
    });
  };
  handleFilterChange = (filterName, e) => {
    const value = e.target.value;
    this.setState({
      [filterName]: value,
      currentPage: 1, // ✅ reset pagination to first page when filter changes
    });
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };

  getUniqueOptions = fieldName => {
    // Always use full data, not filtered
    const allData = this.state.GetAnalyteEvaluation || [];
    const options = new Set();

    allData.forEach(item => {
      const value = item[fieldName];
      if (Array.isArray(value)) {
        value.forEach(v => options.add(v));
      } else if (value) {
        options.add(value);
      }
    });

    return Array.from(options);
  };

  checkFiltersApplied = () => {
    const {
      nameFilter,
      idFilter,
      districtFilter,
      participantFilter,
      schemeFilter,
      schemepriceFilter,
    } = this.state;

    // Check if ANY filter is applied AND has a NON-EMPTY value
    const filters = [
      nameFilter,
      idFilter,
      districtFilter,
      participantFilter,
      schemeFilter,
      schemepriceFilter,
    ];

    const anyFilterSelected = filters.some(f => f && f.trim() !== "");

    this.setState({ filtersApplied: anyFilterSelected });
  };
  navigateToRoundReport = d => {
    const { organization_name } = this.props.match.params;
    if (!organization_name || !d.round_id || !d.participant_id) {
      console.error(
        "Missing organization_name, round_id, or participant_id for navigation",
        d
      );
      return;
    }

    const schemeType = (
      this.state.reportScheme?.analytetype || ""
    ).toLowerCase();
    let url = `/${organization_name}/${d.round_id}/${d.participant_id}/report1_view`;

    if (schemeType === "qualitative") {
      url = `/${organization_name}/${d.round_id}/${d.participant_id}/qualitative_report_view`;
    } else if (schemeType === "identification") {
      url = `/${organization_name}/${d.round_id}/${d.participant_id}/micro-report`;
    }

    this.props.history.push(url);
    this.setState({ showDetailModal: false, qualitativeModalOpen: false });
  };
  render() {
    const { GetAnalyteEvaluation } = this.state;
    const { onGetAnalyte, onGetScheme } = this.props;
    const defaultSorted = [{ dataField: "id", order: "desc" }];
    const { ListDistrict } = this.state;
    const districtOptions = (this.state.ListDistrict || []).map(district => ({
      value: district,
      label: district,
    }));

    const filteredData = this.filterData();

    const totalParticipants = filteredData.length;
    const participantsWithResults = filteredData.filter(
      lab => lab.result_value !== null && lab.result_value !== undefined
    ).length;
    const pageOptions = {
      sizePerPage: 50,
      totalSize: filteredData.length,
      custom: true,
      page: this.state.currentPage || 1,
      onPageChange: page => {
        this.setState({ currentPage: page });
      },
    };
    const schemeType =
      this.state.reportScheme?.analytetype?.toLowerCase() || "";

    const roundColumns = (this.state.selectedSchemeRounds || []).map(
      (round, index) => ({
        dataField: `round_${index + 1}`,
        text: `Round ${index + 1}`,
        sort: true,
        style: { textAlign: "center" },
        formatter: (cell, row) => {
          if (!cell || cell.count === 0) return "NS";
          return (
            <span
              style={{
                color: "blue",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() =>
                this.setState({
                  schemeModalOpen: true,
                  modalParticipantName: `Round ${index + 1}`,
                  hoveredSchemeNames: cell.participants || [], // ✅ use participants
                })
              }
            >
              {cell.count}
            </span>
          );
        },
        headerFormatter: column => (
          <div style={{ textAlign: "center" }}>{column.text}</div>
        ),
      })
    );
    const dynamicAnalyteColumns = (this.state.analytesInScheme || []).map(
      analyte => ({
        dataField: analyte,
        text: (
          <span title={analyte} style={{ cursor: "pointer" }}>
            {getAnalyteShortName(analyte)}
          </span>
        ),
        headerStyle: { textAlign: "center", whiteSpace: "nowrap" },
        style: { textAlign: "center" },
        sort: true,

        sortFunc: (a, b, order, rowA, rowB) => {
          const { statusFilter } = this.state;

          const getValue = row => {
            const key = `${row.lab_id}_${analyte}`;
            const summary = this.state.analyteSummaryMap?.[key] || {};
            const filterKey = statusFilter?.toLowerCase() || "total_rounds";
            if (filterKey === "not_submitted")
              return summary.not_submitted || 0;
            return summary[filterKey] || 0;
          };

          const valA = getValue(rowA);
          const valB = getValue(rowB);

          return order === "asc" ? valA - valB : valB - valA;
        },
        formatter: (cell, row) => {
          const key = `${row.lab_id}_${analyte}`;
          const summary = this.state.analyteSummaryMap?.[key] || {
            total_rounds: 0,
            accepted: 0,
            warning: 0,
            rejected: 0,
            not_submitted: 0,
            detailed_results: [],
          };

          const { statusFilter } = this.state;
          const schemeType =
            this.state.reportScheme?.analytetype?.toLowerCase();

          const statusColors = {
            accepted: "#155724",
            rejected: "#721c24",
            warning: "#004085",
            not_submitted: "#6c757d",
          };

          // 🟣 QUALITATIVE — calculate from whether a result was submitted
          if (schemeType === "qualitative") {
            const detailed = summary.detailed_results || [];
            const closedRounds = detailed.filter(
              d => d.round_status !== "Open"
            );

            const hasResultFn = d =>
              d.qualitative_result_type !== "Not Submitted";

            const acceptedCount = closedRounds.filter(
              d => hasResultFn(d) && d.score === 5
            ).length;
            const rejectedCount = closedRounds.filter(
              d => hasResultFn(d) && d.score === 0
            ).length;
            const notSubmittedCount = closedRounds.filter(
              d => !hasResultFn(d)
            ).length;
            const totalRounds = closedRounds.length;

            const { statusFilter } = this.state;

            return (
              <div
                style={{
                  fontSize: "12px",
                  lineHeight: "16px",
                  textAlign: "center",
                }}
              >
                {/* Show only the selected filter count */}
                {(!statusFilter || statusFilter === "total_rounds") && (
                  <div
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      cursor: totalRounds > 0 ? "pointer" : "default",
                    }}
                    title={`Total Rounds: ${totalRounds}`}
                    onClick={() =>
                      totalRounds > 0 &&
                      this.handleCountClick(
                        row.lab_id,
                        row.scheme_name,
                        row.cycle_no,
                        analyte,
                        "total_rounds"
                      )
                    }
                  >
                    {totalRounds || "-"}
                  </div>
                )}

                {(statusFilter === "accepted" || !statusFilter) && (
                  <div
                    style={{
                      color: statusColors.accepted,
                      cursor: acceptedCount > 0 ? "pointer" : "default",
                    }}
                    title={`Accepted: ${acceptedCount}`}
                    onClick={() =>
                      acceptedCount > 0 &&
                      this.handleCountClick(
                        row.lab_id,
                        row.scheme_name,
                        row.cycle_no,
                        analyte,
                        "accepted"
                      )
                    }
                  >
                    {acceptedCount || "-"}
                  </div>
                )}

                {(statusFilter === "rejected" || !statusFilter) && (
                  <div
                    style={{
                      color: statusColors.rejected,
                      cursor: rejectedCount > 0 ? "pointer" : "default",
                    }}
                    title={`Rejected: ${rejectedCount}`}
                    onClick={() =>
                      rejectedCount > 0 &&
                      this.handleCountClick(
                        row.lab_id,
                        row.scheme_name,
                        row.cycle_no,
                        analyte,
                        "rejected"
                      )
                    }
                  >
                    {rejectedCount || "-"}
                  </div>
                )}

                {(statusFilter === "not_submitted" || !statusFilter) && (
                  <div
                    style={{
                      color: statusColors.not_submitted,
                      cursor: notSubmittedCount > 0 ? "pointer" : "default",
                    }}
                    title={`Not Submitted: ${notSubmittedCount}`}
                    onClick={() =>
                      notSubmittedCount > 0 &&
                      this.handleCountClick(
                        row.lab_id,
                        row.scheme_name,
                        row.cycle_no,
                        analyte,
                        "not_submitted"
                      )
                    }
                  >
                    {notSubmittedCount || "-"}
                  </div>
                )}
              </div>
            );
          }

          // 🧮 QUANTITATIVE — show counts only (no labels)

          const counts = [
            { key: "total_rounds", color: "black" },
            { key: "accepted", color: statusColors.accepted },
            { key: "warning", color: statusColors.warning },
            { key: "rejected", color: statusColors.rejected },
            { key: "not_submitted", color: statusColors.not_submitted },
          ];

          return (
            <div
              style={{
                fontSize: "12px",
                lineHeight: "16px",
                textAlign: "center",
              }}
            >
              {counts
                // 🔽 Show only relevant status when filter is active
                .filter(item => {
                  if (
                    !statusFilter ||
                    statusFilter === "all" ||
                    statusFilter === ""
                  )
                    return true; // show all when no filter selected
                  return item.key === statusFilter; // show only filtered one
                })
                .map(item => {
                  const value = summary[item.key] || 0;
                  return (
                    <div
                      key={item.key}
                      style={{
                        color: item.color,
                        fontWeight:
                          item.key === "total_rounds" ? "bold" : "normal",
                        cursor: value > 0 ? "pointer" : "default",
                      }}
                      title={`${item.key.replace("_", " ")}: ${value}`}
                      onClick={() =>
                        value > 0 &&
                        this.handleCountClick(
                          row.lab_id,
                          row.scheme_name,
                          row.cycle_no,
                          analyte,
                          item.key
                        )
                      }
                    >
                      {value || "-"}
                    </div>
                  );
                })}
            </div>
          );
        },
      })
    );

    // ✅ Step: Conditionally include the "Round" column
    let visibleColumns = [...this.state.feedbackListColumns];

    // Remove or include "Round" column dynamically

    const allColumns = [
      ...visibleColumns,
      ...dynamicAnalyteColumns,
      ...roundColumns,
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Analyte Report | NHS NEQAS</title>
          </MetaTags>

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Labs" breadcrumbItem="PERFORMANCE REPORT " />
            <Row className="justify-content-center align-item-center">
              <Col lg="12">
                {" "}
                {/* <p>
                  <strong>Note:</strong> Click on Scheme Number to get detail of
                  each participants payments
                </p> */}
                <Card>
                  <CardBody>
                    <PaginationProvider
                      key={`tbl-${this.state.analyteFilter || "none"}-${
                        this.state.schemeFilter || "none"
                      }-${this.state.cycleFilter || "none"}-${
                        this.state.roundFilter || "none"
                      }-${this.state.statusFilter || "none"}`}
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.feedbackListColumns}
                      data={this.filterData()}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={allColumns}
                          data={this.filterData()}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <Modal
                                isOpen={this.state.participantModalOpen}
                                toggle={() =>
                                  this.setState({ participantModalOpen: false })
                                }
                                size="lg"
                              >
                                <ModalHeader
                                  toggle={() =>
                                    this.setState({
                                      participantModalOpen: false,
                                    })
                                  }
                                >
                                  {this.state.selectedParticipant}
                                </ModalHeader>
                                <ModalBody>
                                  <Table bordered responsive>
                                    <thead>
                                      <tr>
                                        {Object.keys(
                                          this.state.participantRows?.[0] || {}
                                        ).map(key => (
                                          <th key={key} className="text-center">
                                            {key}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.participantRows?.map(
                                        (row, i) => (
                                          <tr key={i}>
                                            {Object.values(row).map(
                                              (val, idx) => (
                                                <td
                                                  key={idx}
                                                  className="text-center"
                                                >
                                                  {val}
                                                </td>
                                              )
                                            )}
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </Table>
                                </ModalBody>
                              </Modal>

                              <Modal
                                isOpen={this.state.showDetailModal}
                                toggle={() =>
                                  this.setState({ showDetailModal: false })
                                }
                                size="lg"
                              >
                                <ModalHeader
                                  toggle={() =>
                                    this.setState({ showDetailModal: false })
                                  }
                                >
                                  {this.state.modalTitle}
                                </ModalHeader>
                                <ModalBody style={{ overflowX: "auto" }}>
                                  <Table striped bordered hover size="m">
                                    <thead>
                                      <tr>
                                        <th>Round</th>
                                        <th>Unit</th>
                                        <th>Instrument</th>
                                        <th>Method</th>
                                        <th>Reagent</th>
                                        <th>Result</th>
                                        <th>Robust Mean</th>
                                        <th>Z-Score</th>
                                        <th>Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.modalData
                                        .sort((a, b) => {
                                          // Extract numbers from round_name strings, fallback to 0
                                          const getRoundNum = round => {
                                            if (!round) return 0;
                                            const match =
                                              round.match(/-(\d+)$/); // regex to get number
                                            return match ? Number(match[1]) : 0;
                                          };

                                          const roundA =
                                            Number(a.round_number) ||
                                            getRoundNum(a.round_name);
                                          const roundB =
                                            Number(b.round_number) ||
                                            getRoundNum(b.round_name);

                                          return roundA - roundB;
                                        })
                                        .map((d, idx) => {
                                          let statusColor = "#000"; // default black
                                          switch (d.status) {
                                            case "Acceptable":
                                              statusColor = "#155724"; // green
                                              break;
                                            case "Warning":
                                              statusColor = "#004085"; // blue
                                              break;
                                            case "Rejected":
                                              statusColor = "#721c24"; // red
                                              break;
                                            default:
                                              statusColor = "#000";
                                          }

                                          // Score color (red if zero)
                                          const scoreColor =
                                            d.score !== undefined &&
                                            d.score === 0
                                              ? "#721c24"
                                              : "#000";

                                          return (
                                            <tr key={idx}>
                                              <td
                                                style={{
                                                  color: "blue",
                                                  cursor: "pointer",
                                                  textDecoration: "underline",
                                                }}
                                                onClick={() =>
                                                  this.navigateToRoundReport(d)
                                                }
                                              >
                                                {d.round_number || d.round_name}
                                              </td>
                                              <td>{d.unit || "-"}</td>
                                              <td>{d.instrument || "-"}</td>
                                              <td>{d.method || "-"}</td>
                                              <td>{d.reagents || "-"}</td>
                                              <td>{d.result ?? "-"}</td>
                                              <td>{d.robust_mean ?? "-"}</td>
                                              <td>{d.z_score ?? "-"}</td>
                                              <td
                                                style={{
                                                  color: statusColor,
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {d.status ?? "-"}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                    </tbody>
                                  </Table>
                                </ModalBody>
                              </Modal>
                              <Modal
                                isOpen={this.state.qualitativeModalOpen}
                                toggle={() =>
                                  this.setState({ qualitativeModalOpen: false })
                                }
                                size="lg"
                              >
                                <ModalHeader
                                  toggle={() =>
                                    this.setState({
                                      qualitativeModalOpen: false,
                                    })
                                  }
                                >
                                  {this.state.modalTitle}
                                </ModalHeader>
                                <ModalBody>
                                  <Table bordered responsive hover>
                                    <thead className="table-light">
                                      <tr>
                                        <th>Round</th>
                                        <th>Instrument</th>
                                        <th>Your Result</th>
                                        <th>Expected Result</th>
                                        <th>Score</th>
                                        <th>Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.qualitativeModalData?.length >
                                      0 ? (
                                        this.state.qualitativeModalData.map(
                                          (row, i) => (
                                            <tr key={i}>
                                              <td
                                                style={{
                                                  color: "blue",
                                                  cursor: "pointer",
                                                  textDecoration: "underline",
                                                }}
                                                onClick={() =>
                                                  this.navigateToRoundReport(
                                                    row
                                                  )
                                                }
                                              >
                                                {row.round_name}
                                              </td>
                                              <td>{row.instrument}</td>
                                              <td className="text-center">
                                                {row.your_result}
                                              </td>
                                              <td className="text-center">
                                                {row.expected_result}
                                              </td>
                                              <td className="text-center">
                                                {row.score}
                                              </td>
                                              <td
                                                className="text-center"
                                                style={{
                                                  color:
                                                    row.status === "Accepted"
                                                      ? "#155724"
                                                      : row.status ===
                                                        "Rejected"
                                                      ? "#721c24"
                                                      : "#000",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {row.status}
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan="5"
                                            className="text-center"
                                          >
                                            No qualitative results available
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </Table>
                                </ModalBody>
                              </Modal>

                              <Row className="mb-3">
                                <Col md={4}>
                                  <Label>Scheme</Label>
                                  <Select
                                    options={[
                                      { value: "All", label: "All Schemes" },
                                      ...(this.props.SchemeList || []).map(
                                        s => ({
                                          value: s.id,
                                          label: s.name,
                                        })
                                      ),
                                    ]}
                                    onChange={this.handleSchemeChange}
                                    value={
                                      this.state.schemeFilter
                                        ? {
                                            value: this.state.schemeFilter,
                                            label:
                                              this.props.SchemeList.find(
                                                s =>
                                                  s.id ===
                                                  this.state.schemeFilter
                                              )?.name || "",
                                          }
                                        : null
                                    }
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label>Cycle</Label>
                                  <Select
                                    options={[
                                      { value: "All", label: "All Cycles" },
                                      ...(this.state.filteredCycles || []).map(
                                        cycle => ({
                                          value: cycle,
                                          label: `Cycle ${cycle}`,
                                        })
                                      ),
                                    ]}
                                    onChange={this.handleCycleChange}
                                    value={
                                      this.state.cycleFilter
                                        ? {
                                            value: this.state.cycleFilter,
                                            label: `Cycle ${this.state.cycleFilter}`,
                                          }
                                        : null
                                    }
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label>District</Label>
                                  <Select
                                    options={[
                                      { value: "All", label: "All Districts" },
                                      ...(this.state.ListDistrict || []).map(
                                        d => ({
                                          value: d,
                                          label: d,
                                        })
                                      ),
                                    ]}
                                    onChange={selected =>
                                      this.handleDistrictChange(
                                        selected?.value === "All"
                                          ? ""
                                          : selected?.value
                                      )
                                    }
                                    value={
                                      this.state.districtFilter
                                        ? {
                                            value: this.state.districtFilter,
                                            label: this.state.districtFilter,
                                          }
                                        : {
                                            value: "All",
                                            label: "All Districts",
                                          } // default when none selected
                                    }
                                  />
                                </Col>

                                <Col md={3}>
                                  <Label>Status</Label>
                                  <Select
                                    options={[
                                      { value: "All", label: "All" },
                                      { value: "accepted", label: "Accepted" },
                                      { value: "rejected", label: "Rejected" },
                                      {
                                        value: "not_submitted",
                                        label: "Not Submitted",
                                      },
                                      ...(schemeType !== "qualitative"
                                        ? [
                                            {
                                              value: "warning",
                                              label: "Warning",
                                            },
                                          ]
                                        : []),
                                    ]}
                                    onChange={selected =>
                                      this.setState({
                                        statusFilter:
                                          selected?.value === "All"
                                            ? ""
                                            : selected?.value.toLowerCase(),
                                      })
                                    }
                                    value={
                                      this.state.statusFilter
                                        ? {
                                            value: this.state.statusFilter,
                                            label:
                                              this.state.statusFilter
                                                .charAt(0)
                                                .toUpperCase() +
                                              this.state.statusFilter
                                                .slice(1)
                                                .replace("_", " "),
                                          }
                                        : { value: "All", label: "All" }
                                    }
                                  />
                                </Col>
                              </Row>

                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-condensed table-hover"
                                      }
                                      bordered={false}
                                      striped={true}
                                      headerWrapperClasses={
                                        "table-header-sky-blue"
                                      }
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
AnalyteEvaluationReport.propTypes = {
  GetAnalyteEvaluation: PropTypes.array,
  AnalyteEvaluationReport: PropTypes.object,
  onGetAnalyteEvaluationReport: PropTypes.func,
  AnalyteList: PropTypes.array,
  onGetAnalyte: PropTypes.func,
  match: PropTypes.object,
  SchemeList: PropTypes.array,
  onGetScheme: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

const mapStateToProps = state => {
  console.log(
    "Redux State in mapStateToProps (AnalyteEvaluationReport page):",
    state
  );

  return {
    AnalyteList: state.ListUnit?.ListUnit || [],
    AnalyteEvaluationReport: state.AddPayment?.GetAnalyteEvaluation || {},
    SchemeList: state.SchemeList?.SchemeList || [], // ✅ Add this line
  };
};

const mapDispatchToProps = dispatch => ({
  onGetAnalyteEvaluationReport: id => dispatch(getanalyteevaluationreport(id)),
  onGetScheme: id => dispatch(getSchemelist(id)),
  onGetAnalyte: id => dispatch(getAnalytelist(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AnalyteEvaluationReport));
